import {createSelector} from 'reselect';
import {getBookingType, getListingIds, getPricingBadges, getRankedBadges} from './listing';
import {getBrandId} from './system';
import {getTranslations} from './store';
import getListingSourceId from '../utils/getListingSourceId';
import {familyCollectionIsPresent} from '@homeaway/react-family-collection-callout';

const getPremierPartnerBadge = createSelector(
    [getRankedBadges],
    (rankedBadges) => {
        const premierPartner = '1';
        const premierPartnerBadge = rankedBadges.find((badge) => badge.id === premierPartner);
        return premierPartnerBadge || {};
    }
);

const getInstallmentsBadge = createSelector(
    [getBookingType, getListingIds, getBrandId, getTranslations],
    (bookingType, listingIds, brandId, translations) => {
        const HOMEAWAY_BR_ID = '126';
        const listingSourceSiteId = getListingSourceId(listingIds.listingId);
        const isBrazilSourceSite = listingSourceSiteId === HOMEAWAY_BR_ID;
        const isBrazil = brandId === HOMEAWAY_BR_ID;
        if (isBrazil && isBrazilSourceSite && bookingType.onlineBookable) {
            return {label: translations.installmentsBadge};
        }
        return {};
    }
);

const getNldBadge = createSelector(
    [getPricingBadges],
    (pricingBadges) => {
        if (pricingBadges.length === 0) {
            return {};
        }
        return pricingBadges[0];
    }
);

const getFamilyCollectionBadge = createSelector(
    [getRankedBadges],
    (rankedBadges) => {
        return familyCollectionIsPresent(rankedBadges);
    }
);

export {getPremierPartnerBadge, getInstallmentsBadge, getNldBadge, getFamilyCollectionBadge};
